import Icon from '../../components/Icon.vue'

Icon.register({"regular/square":{"width":448,"height":512,"paths":[{"d":"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM394 432H54C50.7 432 48 429.3 48 426V86C48 82.7 50.7 80 54 80H394C397.3 80 400 82.7 400 86V426C400 429.3 397.3 432 394 432z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/square.js
// module id = sIrB
// module chunks = 0